import { render, staticRenderFns } from "./iSpringQuizView.vue?vue&type=template&id=1dd1e276&"
import script from "./iSpringQuizView.vue?vue&type=script&lang=js&"
export * from "./iSpringQuizView.vue?vue&type=script&lang=js&"
import style0 from "./iSpringQuizView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports